import { FilterTypesEnum } from '../FilterTypesEnum';
import { FilterModel } from './filter.model';

export class HasManualChangesFilterModel extends FilterModel {
  override symbol: FilterTypesEnum = FilterTypesEnum.has_manual_changes;

  isValid() {
    return !!this.value;
  }
}
